import React, { FC } from 'react';
import { Player, FormationCell } from '../types';
import { DraggableCounter } from './DraggableCounter';
import './RosterBench.css';

interface RosterBenchProps {
  players: Player[];
  layout: FormationCell[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  onReturn: (id: number) => void;
}

export const RosterBench: FC<RosterBenchProps> = ({
  players,
  layout,
  selectedId,
  onSelect,
  onReturn,
}) => {
  const isPlaced = (num: number) =>
    layout.some((c) => c.playerNumber === num);

  return (
    <div className="roster-bench">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>
          {players.map((p) => {
            const placed = isPlaced(p.number);

            return (
              <tr
                key={p.number}
                className={p.number === selectedId ? 'active' : ''}
                onClick={() => onSelect(p.number)}
              >
                <td>
                  {!placed ? (
                    <DraggableCounter
                      id={p.number}
                      placed={placed}
                      onReturn={onReturn}
                      player={p}
                    />
                  ) : (
                    <span className="placeholder" style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '28px',
                      height: '28px',
                      borderRadius: '50%',
                      backgroundColor: '#334155',
                      color: '#94a3b8',
                      fontSize: '11px',
                      fontWeight: 700,
                      opacity: 0.5
                    }}>{p.number}</span>
                  )}
                </td>
                <td>{p.name || '–'}</td>
                <td>{p.position || '–'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
